import AddInformationMarkerModalView from "./addInformationMarkerModal.html";
import { Loader } from "@googlemaps/js-api-loader"
import IconPicker from '../../../../scripts/iconpicker-1.5.0.js';
import $ from "jquery";

angular.module("locations")

    .controller("LocationsEditCtrl", ['LoginService', '$scope', '$rootScope', '$state', '$stateParams', 'Restangular', 'gridService', '$filter', '$translate', 'modalService', '$uibModal', '$timeout', '$window',
        function (LoginService, $scope, $rootScope, $state, $stateParams, Restangular, gridService, $filter, $translate, modalService, $uibModal, $timeout, $window) {
            const loader = new Loader({
                apiKey: "AIzaSyBXOP6yX_55SzBTIQi1Yt_Kal5wG2MYHYo",
                version: "weekly"
            });

            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("LOCATIONS_READ");

            $rootScope.title = $filter('translate')('locations.title');

            $scope.location_id = $stateParams.id;

            $scope.locations = {
                color: "#c1bfbf"
            };
                     

            $scope.adictionalMarks = [];

            Restangular.all('Locations').getList().then(function (locations) {
                $scope.selectLocations = locations;
                if (!angular.isUndefined($stateParams.id) || $stateParams.id != "") {
                    var index = $scope.selectLocations.findIndex(x => x.id == $stateParams.id);
                    $scope.selectLocations.splice(index, 1);
                }
            });

            $scope.select = {};

            $scope.select.location_country = null;
            $scope.select.location_region = null;
            $scope.searching = false;

            $scope.refresh = {};

            $scope.getLocationsSearch = function (val) {
                if (val == null) {
                    val = '';
                } else {
                    val = val.replace(/[:.?*+^$[\\(){|]/, "");
                }
                let ret = [];
                ret = Restangular.all('SearchLocation/' + val).getList().then(function (searchTerms) {
                    return searchTerms;
                });

                return ret;
            };

            if (angular.isUndefined($scope.location_id) || $scope.location_id == "") {

                $rootScope.breadcrumb = [
                    { title: $filter('translate')('locations.title'), url: "locations.list" },
                    { title: $filter('translate')('locations.button_add') },
                ];

            } else {
                $rootScope.breadcrumb = [
                    { title: $filter('translate')('locations.title'), url: "locations.list" },
                    { title: $filter('translate')('locations.button_edit') },
                ];

                Restangular.one('Locations', $scope.location_id).get().then(function (result) {

                    $scope.locations = result;

                    if (result.country_region_city_id != null) {
                        Restangular.all('getLocationByCity/' + result.country_region_city_id).getList().then(function (searchTerms) {
                            $scope.locations.fullLocation = searchTerms[0].country + ", " + searchTerms[0].region+", "+searchTerms[0].city;
                        });
                    }

                    $scope.location_id = $scope.locations.id;
                    $scope.adictionalMarks = result.FK_locations_markers_locations_markers;

                    initMap(result.gps_latitude, result.gps_longitude, null);

                });

            }

            $scope.saveLocations = function () {

                if (!angular.isUndefined($stateParams.id) && $stateParams.id != "") {
                    $scope.locations.put().then(function (result) {
                        if (angular.isDefined(result.id)) {
                            //$scope.reloadMarkers(null, null);
                        } else {
                            $scope.errorMessage = result.message;
                        }
                    });
                } else {
                    Restangular.all('Locations').post($scope.locations).then(function (result) {
                        if (angular.isDefined(result.id)) {
                            var fullLocation = $scope.locations.fullLocation.country + ", " + $scope.locations.fullLocation.region + ", " + $scope.locations.fullLocation.city;
                            $scope.locations = result;
                            $scope.locations.fullLocation = fullLocation;
                            $scope.location_id = result.id;
                            $stateParams.id = result.id;
                            $scope.reloadMarkers(null, null);
                        } else {
                            $scope.errorMessage = result.message;
                        }
                    });
                }
            }

            $scope.changedLocation = async function () {
                if (navigator.geolocation) {
                    loader.importLibrary("geocoding").then(async ({Geocoder}) => {
                        const geocoder = new Geocoder();
                        var fullAddress = $scope.locations.name_in_map + ", " + $scope.locations.fullLocation.city + ", " + $scope.locations.fullLocation.country;
                        $scope.locations.country_region_city_id = $scope.locations.fullLocation.city_id;
                        geocoder.geocode({ address: fullAddress }).then(function (data) {
                            if (data.results.length > 0) {
                                var location = JSON.parse(JSON.stringify(data.results[0].geometry.location.toJSON(), null, 2));
                                $scope.locations.gps_latitude = location.lat;
                                $scope.locations.gps_longitude = location.lng;
                                initMap(location.lat, location.lng, null, data.results[0].formatted_address);
                            } else {
                                window.alert("No results found");
                            }
                        });
                    });
                };
            }

            $scope.deleteMarker = function (id, typeMarker) {
                modalService.confirm({
                    title: $filter('translate')('locations.delete_title'),
                    message: $filter('translate')('locations.delete_marks')+ "?",
                    onAccept: function () {
                        Restangular.all('Locations/DeleteMark').remove({ id: id, typeMarker: typeMarker }).then(function (result) {
                            $scope.reloadMarkers(null,null);
                        });
                    }
                });
            };

            $scope.map;
            $scope.markers = [];
            $scope.markerId = 1;
            $scope.zoom = 16;

            //Mapa Google
            function initMap(latitude, longitude, contextMenu, formatted_address = null) {
                if (!angular.isUndefined($scope.location_id) || $scope.location_id != "") {
                    loader.load().then(async  () => {
                        const { Map, OverlayView, InfoWindow } = await google.maps.importLibrary("maps") as google.maps.MapsLibrary;
                        const { Marker } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;

                                            //Map initialization
                        var latlng = { lat: latitude, lng: longitude };
                        var myOptions = {
                            zoom: $scope.zoom,
                            center: latlng,
                            mapTypeId: google.maps.MapTypeId.ROADMAP
                        };
                        $scope.map = new Map(document.getElementById("map_canvas"), myOptions);
                        $scope.overlay = new OverlayView();
                        $scope.overlay.draw = function () { }; // empty function required
                        $scope.overlay.setMap($scope.map);
                        $scope.element = document.getElementById('map_canvas');

                        const map = $scope.map;
                        const infoWindow = new google.maps.InfoWindow();

                        if (formatted_address != null) {
                            map.setZoom(16);
                            map.setCenter(latlng);

                            const marker = new Marker({
                                map,
                                position: latlng,
                            });

                            infoWindow.setContent(formatted_address);
                            infoWindow.open(map, marker);
                        } 
                        
                        
                        if (!angular.isUndefined(contextMenu) || contextMenu != null) {
                            map.controls[google.maps.ControlPosition.TOP_CENTER].push(contextMenu);
                        } else {
                            let contextMenu = document.getElementById('contextMenu');
                            map.controls[google.maps.ControlPosition.TOP_CENTER].push(contextMenu);
                        }                                        

                        
                        $timeout(function () {
                            //hideContextMenu();
                            angular.forEach($scope.locations.positions, function (position) {

                                var findDesc = $filter('filter')($scope.locations.FK_locations_markers_locations_markers, { 'gps_latitude': position.lat });
                                var description = "";
                                var svgMarker = {};
                                var iconMain = {};

                                if (findDesc.length > 0) {
                                    description = findDesc[0].description_marker;
                                    if (findDesc[0].icon != null) {
                                        svgMarker = getIconUnicode("fas fa-" + findDesc[0].icon);
                                    } else {
                                        svgMarker = "";
                                    }
                                    
                                } else {
                                    description = $scope.locations.description_marker;
                                    iconMain = {
                                        path: "M-1.547 12l6.563-6.609-1.406-1.406-5.156 5.203-2.063-2.109-1.406 1.406zM0 0q2.906 0 4.945 2.039t2.039 4.945q0 1.453-0.727 3.328t-1.758 3.516-2.039 3.070-1.711 2.273l-0.75 0.797q-0.281-0.328-0.75-0.867t-1.688-2.156-2.133-3.141-1.664-3.445-0.75-3.375q0-2.906 2.039-4.945t4.945-2.039z",
                                        fillColor: "#d69053",
                                        fillOpacity: 1,
                                        strokeWeight: 0,
                                        rotation: 0,
                                        scale: 2,
                                        anchor: new google.maps.Point(0, 20),
                                    };
                                }

                                const marker = new Marker({
                                    position,
                                    map,
                                    title: description,
                                    optimized: false,
                                    icon: (Object.entries(iconMain).length === 0?'':iconMain) as string,
                                    label: {
                                        text: (Object.entries(svgMarker).length === 0 ? {} : svgMarker) as string,
                                        fontFamily: 'FontAwesome',
                                    }
                                });


                                marker.addListener("click", () => {
                                    infoWindow.close();
                                    infoWindow.setContent(marker.getTitle());
                                    infoWindow.open(marker.getMap(), marker);
                                });

                            });

                        }, 1000);

                        map.addListener("rightclick", (e) => {
                            showContextMenu(e);
                            $scope.eventLatLng = e.latLng;
                            $scope.zoom = map.getZoom();
                            //e.preventDefault();
                        });

                    });    
                }
            }

            $scope.reloadMarkers = function (gps_aditinal_latitude, gps_aditional_longitude) {
                Restangular.one('Locations', $scope.location_id).get().then(function (result) {
                    $scope.adictionalMarks = result.FK_locations_markers_locations_markers;
                    var fullLocation = $scope.locations.fullLocation;
                    $scope.locations = result;
                    $scope.locations.fullLocation = fullLocation;
                    $('#contextMenu').css("display", "block");
                    let contextMenu = document.getElementById('contextMenu');
                    hideContextMenu();

                    if ($scope.locations.gps_latitude != null) {
                        if (gps_aditinal_latitude != null && gps_aditional_longitude != null) {
                            initMap(gps_aditinal_latitude, gps_aditional_longitude, contextMenu);
                        } else {
                            initMap($scope.locations.gps_latitude, $scope.locations.gps_longitude, contextMenu);
                        }
                        
                    } else {
                        if (navigator.geolocation) {
                            navigator.geolocation.getCurrentPosition(function (position) {
                                initMap(position.coords.latitude, position.coords.longitude, contextMenu);
                            });
                        };
                    }
                });
            }

            function showContextMenu(event) {
                if (angular.isUndefined($scope.locations.id) || $scope.locations.id == null) {
                    modalService.message({
                        title: "Mensaje",
                        message: "Debe guardar antes los cambios!",
                        onAccept: function () { }
                    });

                } else {
                    angular.element()
                    $('#contextMenu').css("display", "block");
                    $('#contextMenu').css("position", "absolute");
                    $('#contextMenu').css({
                        left: event.pixel.x,
                        top: event.pixel.y
                    })
                }
            }

            $scope.clickMainMarker = function (e) {
                var result = JSON.parse(JSON.stringify(e.toJSON(), null, 2));
                $scope.locations.gps_latitude = result.lat;
                $scope.locations.gps_longitude = result.lng;

                $scope.locations.put().then(function (result) {
                    if (angular.isDefined(result.id)) {
                        $scope.reloadMarkers(null,null);
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            }

            $scope.goToCountries = function () {
                var url = $state.href('countries.list', {});
                window.open(url, '_blank');
            }

            $scope.clickPopup = function (e) {               
                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: AddInformationMarkerModalView,
                    controller: "LocationMarkerModalCtrl",
                    size: 'md',
                    resolve: {
                        latLng: function () {
                            return e;
                        },
                        locations: function(){
                            return $scope.locations;
                        }
                    }
                });

                //Retorno de los datos desde el moda l.
                $modalInstance.result.then(function (result) {
                    if (result.id != 0 && result.id!=null) {
                        $scope.location_id = result.id;
                    }

                    $scope.reloadMarkers(result.gps_latitude, result.gps_longitude);
                }, function () {
                    console.info('Modal dismissed at: ' + new Date());
                });

                hideContextMenu();
            }

            function hideContextMenu() {
                $('#contextMenu').css("display", "none");
            }

            function getIconUnicode(iconClass) {
                var tempElement = document.createElement("i");
                tempElement.className = iconClass;
                const iconUnicodeCache = {};
                document.body.appendChild(tempElement);
                var character = window.getComputedStyle(tempElement, ':before').getPropertyValue('content').replaceAll(`"`, "");
                tempElement.remove();

                if (character) {
                    iconUnicodeCache[iconClass] = character;
                }
                
                return character;
            }

        }])

    .controller("LocationMarkerModalCtrl", ['LoginService', '$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', '$http', '$stateParams', '$q', '$timeout', 'latLng', 'locations', function (LoginService, $scope, $uibModalInstance, Restangular, modalService, $filter, $http, $stateParams, $q, $timeout, latLng, locations) {

    $timeout(function () {
        IconPicker.Init({
            // Required: You have to set the path of IconPicker JSON file to "jsonUrl" option. e.g. '/content/plugins/IconPicker/dist/iconpicker-1.5.0.json'
            jsonUrl: '/assets/iconpicker-1.5.0.json',
            // Optional: Change the buttons or search placeholder text according to the language.
            searchPlaceholder: 'Search Icon',
            showAllButton: 'Show All',
            cancelButton: 'Cancel',
            noResultsFound: 'No results found.', // v1.5.0 and the next versions
            borderRadius: '20px', // v1.5.0 and the next versions
        });

        IconPicker.Run('#GetIconPicker', function () {
            // ng-bind no funciona para asignar el icono porque no detecta el cambio que hacemos con el IconPicker, así que hay que hacerlo a pelo.
            let icon = document.querySelector("#IconPreview").getAttribute("class");
            icon = icon.substring(icon.indexOf('-') + 1);
            $scope.marker.icon = icon;

        });

    }, 1000),



    //Comprobamos si tiene permiso escritura
    $scope.marker = {
        location_id: null,
        gps_latitude: null,
        gps_longitude: null,
        description_marker: null
    };
    var result = JSON.parse(JSON.stringify(latLng.toJSON(), null, 2));
    $scope.marker.gps_latitude = result.lat;
    $scope.marker.gps_longitude = result.lng;
    $scope.marker.location_id = locations.id;

        $scope.saveMarker = function () {
        if (locations.gps_latitude == null && locations.gps_longitude == null) {
            locations.gps_latitude = $scope.marker.gps_latitude;
            locations.gps_longitude = $scope.marker.gps_longitude;
            locations.description_marker = $scope.marker.description_marker;
            locations.put().then(function (result) {
                if (angular.isDefined(result.id)) {
                    $uibModalInstance.close(result.id);
                }
            });
        } else {
            Restangular.all('Locations').customPOST($scope.marker, "SaveLocationsMarkers", {}).then(function (result) {
                $uibModalInstance.close(result);
            });
        }
    }

    $scope.onCancel = function () {
        $uibModalInstance.dismiss('cancel');
    };

}]);